<template>
    <div class="search-subjects-container">
        <div class="search-subjects" v-for="subject of subjects" :key="subject.id">
            <typo class="search-title">
                {{ subject.label ? subject.label.toLowerCase() : "" }}
            </typo>
            <v-switch v-model="subjectsRequired" color="primary" :value="subject.code" />
        </div>
    </div>
</template>

<script>
import Typo from "src/components/common/typo/Typo.vue";

export default {
    props: ["subjects", "displayedSubjects"],
    components: { Typo },
    data() {
        return {
            subjectsRequired: this.displayedSubjects.map(subject => subject.code),
        };
    },
    mounted() {
        this.$emit("input", this.subjectsRequired);
    },
    watch: {
        async subjectsRequired(value) {
            this.$emit("input", value);
        },
        displayedSubjects(_displayedSubjects) {
            this.subjectsRequired = _displayedSubjects.map(subject => subject.code);
        },
    },
};
</script>

<style lang="sass" scoped>
.search-subjects-container
    width: 100%
    padding: 10px 10px

.search-subjects
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between

.search-title
    &::first-letter
        text-transform: capitalize
</style>
